import { render, staticRenderFns } from "./TaxesPage.vue?vue&type=template&id=1c2cfa3a&scoped=true&"
import script from "./TaxesPage.vue?vue&type=script&lang=js&"
export * from "./TaxesPage.vue?vue&type=script&lang=js&"
import style0 from "./TaxesPage.vue?vue&type=style&index=0&id=1c2cfa3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2cfa3a",
  null
  
)

export default component.exports